module.exports = __webpack_public_path__ + "img/Jump Screenshoot (0-00-09-06).b4e5b323.jpg";